module.exports = __webpack_public_path__ + "static/media/activation.afa86b8b.svg";